import Fire from './Fire'

export default Fire
// eslint-disable-next-line import/export
export * from './Fire'
